









































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";
import { appModule } from "@/store/modules/app";
import { storePerawat } from "@/store/modules/perawat";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import moment from "moment";
import { LIMA_BENAR } from "@/constants/cpoLimaBenar";

interface DataPemberian {
  id: number;
  cpo_item_id: number;
  nama_obat: string;
  ham_lasa: string;
  rute: string;
  dr_id: string;
  kd_obat: string;
  unit_id: string;
  dosis: string;
  jadwal: string;
  tgl: string;
  time: string;
  verified_at: string;
  benar_pasien?: boolean | number | null;
  benar_obat?: boolean | number | null;
  benar_dosis?: boolean | number | null;
  benar_waktu?: boolean | number | null;
  benar_rute?: boolean | number | null;
}

@Component({
  components: {
    ModalKonfirmasi
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CpoPemberianModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() verifikator: string;
  @Prop() disabled: boolean;
  @Prop({ required: true }) dataPemberian!: DataPemberian;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtd = false;
  alert = "";
  saving = false;
  removing = false;
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  menu2 = false;
  menuLimaBenar = false;
  limaBenar = LIMA_BENAR;

  mounted() {}

  get semuaBenar(): boolean {
    return this.limaBenar.every(item => this.input[item.key] === true);
  }

  centangSemuaBenar(val) {
    this.limaBenar.forEach(item => {
      this.input[item.key] = !!val;
    });
  }

  get limaBenarPayload(): Record<string, boolean> {
    return this.limaBenar.reduce((hasil, item) => {
      hasil[item.key] = this.input[item.key] === true;
      return hasil;
    }, {} as Record<string, boolean>);
  }

  get storeUser() {
    return userModule.user;
  }

  get listPerawat() {
    return storePerawat.listPerawat.filter(p => p.id != this.storeUser.id);
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("value")
  changeValue(val) {}

  @Watch("input.time")
  changeJam(val) {
    const now = new Date();
    const today = moment(now).format("YYYY-MM-DD");
    const currentTime = moment(now).format("HH:mm:ss");
    if (!val) return;
    if (!this.input.date) return;
    if (this.input.date !== today) {
      return;
    }
    if (val > currentTime) {
      alert("Jam tidak boleh melebihi jam sekarang");
      this.input.time = currentTime;
    }
  }

  input: any = {
    id: null,
    cpo_item_id: null,
    date: "",
    time: "",
    unit_id: null,
    dosis_text: "",
    verifikator_user_id: null,
    benar_pasien: false,
    benar_obat: false,
    benar_dosis: false,
    benar_waktu: false,
    benar_rute: false
  };

  @Watch("dataPemberian", { immediate: true, deep: true })
  onDataPemberianChange(val) {
    if (!val) return;

    this.input.id = val.id;
    this.input.cpo_item_id = val.cpo_item_id;
    this.input.date = val.tgl;
    this.input.time = val.time ? val.time : moment().format("HH:mm:ss");
    this.input.unit_id = val.unit_id;
    this.input.dosis_text = val.dosis;
    this.input.verifikator_user_id = this.verifikator;
    this.limaBenar.forEach(item => {
      this.input[item.key] = !!val[item.key];
    });
    this.menuLimaBenar = false;
  }

  async save() {
    if (this.readOnly) return;
    if (!this.input.dosis_text) {
      alert("isi dosis dulu");
      return;
    }
    if (!this.input.time) {
      alert("isi waktu dulu");
      return;
    }
    if (!this.semuaBenar) {
      alert("lengkapi verifikasi 5 benar dulu");
      this.menuLimaBenar = true;
      return;
    }
    if (this.dataPemberian.ham_lasa && !this.input.verifikator_user_id) {
      alert("isi nama verifikator dulu");
      return;
    }
    if (!this.saving) {
      this.saving = true;
      const save = this.input.id
        ? SvcCatatanPemberianObat.updatePemberian(this.input.id, this.input)
        : SvcCatatanPemberianObat.addPemberian(this.input);
      save
        .then(resp => {
          if (resp.status == 1) {
            const namaPerawat = this.listPerawat.find(
              p => p.id === this.input.verifikator_user_id
            );
            const verifikator = this.input.verifikator_user_id
              ? {
                  id: this.input.verifikator_user_id,
                  nama: namaPerawat ? namaPerawat.nama : null
                }
              : null;
            appModule.NoticeDelay("Berhasil menambahkan pemberian obat");
            // this.$emit("reload");
            if (this.input.id) {
              this.$emit("replace", {
                kodeObat: this.dataPemberian.kd_obat,
                id: this.input.id,
                patch: {
                  dosis_text: this.input.dosis_text,
                  time: this.input.time,
                  verifikator: verifikator,
                  ...this.limaBenarPayload
                }
              });
            } else {
              this.$emit("add", {
                kodeObat: this.dataPemberian.kd_obat,
                pemberian: {
                  id: resp.data.id,
                  date: this.input.date,
                  time: this.input.time,
                  unit_id: this.input.unit_id,
                  dosis_text: this.input.dosis_text,
                  verified_at: null,
                  ...this.limaBenarPayload,
                  pemberi: {
                    id: this.storeUser.id,
                    nama: this.storeUser.nama
                  },
                  verifikator: verifikator
                }
              });
            }
            this.dataPemberian.time = "";
            this.dialog = false;
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.dataPemberian.time = "";
    this.verifikator = null;
    this.dialog = false;
  }

  konfirmHapus() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = "Anda yakin ingin hapus pemberian obat ini";
  }

  hapus() {
    if (this.readOnly) return;
    if (!this.removing) {
      this.removing = true;
      SvcCatatanPemberianObat.hapusPemberian(this.input.id)
        .then(resp => {
          if (resp.status == 1) {
            appModule.NoticeDelay("Berhasil menghapus pemberian obat");
            this.$emit("delete", {
              kodeObat: this.dataPemberian.kd_obat,
              id: this.input.id
            });
            this.dataPemberian.time = "";
            this.dialog = false;
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.removing = false;
        });
    }
  }
}
